// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/construction_types.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/construction_types.proto.
 */
export const file_api_proto_v1_construction_types: GenFile = /*@__PURE__*/
  fileDesc("CiVhcGlfcHJvdG8vdjEvY29uc3RydWN0aW9uX3R5cGVzLnByb3RvEgxhcGlfcHJvdG8udjEiiQEKEENvbnN0cnVjdGlvblR5cGUSDAoEbmFtZRgBIAEoCRINCgVsYWJlbBgCIAEoCRIrCgdjcmVhdGVkGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIrCgd1cGRhdGVkGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCI8Ch1DcmVhdGVDb25zdHJ1Y3Rpb25UeXBlUmVxdWVzdBIMCgRuYW1lGAEgASgJEg0KBWxhYmVsGAIgASgJIlsKHkNyZWF0ZUNvbnN0cnVjdGlvblR5cGVSZXNwb25zZRI5ChFjb25zdHJ1Y3Rpb25fdHlwZRgBIAEoCzIeLmFwaV9wcm90by52MS5Db25zdHJ1Y3Rpb25UeXBlIjwKHVVwZGF0ZUNvbnN0cnVjdGlvblR5cGVSZXF1ZXN0EgwKBG5hbWUYASABKAkSDQoFbGFiZWwYAiABKAkiWwoeVXBkYXRlQ29uc3RydWN0aW9uVHlwZVJlc3BvbnNlEjkKEWNvbnN0cnVjdGlvbl90eXBlGAEgASgLMh4uYXBpX3Byb3RvLnYxLkNvbnN0cnVjdGlvblR5cGUiLQodRGVsZXRlQ29uc3RydWN0aW9uVHlwZVJlcXVlc3QSDAoEbmFtZRgBIAEoCSIgCh5EZWxldGVDb25zdHJ1Y3Rpb25UeXBlUmVzcG9uc2UiKgoaR2V0Q29uc3RydWN0aW9uVHlwZVJlcXVlc3QSDAoEbmFtZRgBIAEoCSJYChtHZXRDb25zdHJ1Y3Rpb25UeXBlUmVzcG9uc2USOQoRY29uc3RydWN0aW9uX3R5cGUYASABKAsyHi5hcGlfcHJvdG8udjEuQ29uc3RydWN0aW9uVHlwZSJBCh5HZXRDb25zdHJ1Y3Rpb25UeXBlTGlzdFJlcXVlc3QSDAoEcGFnZRgBIAEoAxIRCglwYWdlX3NpemUYAiABKAMihgEKH0dldENvbnN0cnVjdGlvblR5cGVMaXN0UmVzcG9uc2USOgoSY29uc3RydWN0aW9uX3R5cGVzGAEgAygLMh4uYXBpX3Byb3RvLnYxLkNvbnN0cnVjdGlvblR5cGUSEwoLdG90YWxfY291bnQYAiABKAMSEgoKdG90YWxfcGFnZRgDIAEoA0IzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * 工種タイプ
 *
 * @generated from message api_proto.v1.ConstructionType
 */
export type ConstructionType = Message<"api_proto.v1.ConstructionType"> & {
  /**
   * 工種名（例：roof_paint, exterior_paint）
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 工種ラベル（例：屋根塗装、外壁塗装）
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 3;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 4;
   */
  updated?: Timestamp;
};

/**
 * Describes the message api_proto.v1.ConstructionType.
 * Use `create(ConstructionTypeSchema)` to create a new message.
 */
export const ConstructionTypeSchema: GenMessage<ConstructionType> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 0);

/**
 * 工種タイプ作成リクエスト
 *
 * @generated from message api_proto.v1.CreateConstructionTypeRequest
 */
export type CreateConstructionTypeRequest = Message<"api_proto.v1.CreateConstructionTypeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message api_proto.v1.CreateConstructionTypeRequest.
 * Use `create(CreateConstructionTypeRequestSchema)` to create a new message.
 */
export const CreateConstructionTypeRequestSchema: GenMessage<CreateConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 1);

/**
 * 工種タイプ作成レスポンス
 *
 * @generated from message api_proto.v1.CreateConstructionTypeResponse
 */
export type CreateConstructionTypeResponse = Message<"api_proto.v1.CreateConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.ConstructionType construction_type = 1;
   */
  constructionType?: ConstructionType;
};

/**
 * Describes the message api_proto.v1.CreateConstructionTypeResponse.
 * Use `create(CreateConstructionTypeResponseSchema)` to create a new message.
 */
export const CreateConstructionTypeResponseSchema: GenMessage<CreateConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 2);

/**
 * 工種タイプ更新リクエスト
 *
 * @generated from message api_proto.v1.UpdateConstructionTypeRequest
 */
export type UpdateConstructionTypeRequest = Message<"api_proto.v1.UpdateConstructionTypeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message api_proto.v1.UpdateConstructionTypeRequest.
 * Use `create(UpdateConstructionTypeRequestSchema)` to create a new message.
 */
export const UpdateConstructionTypeRequestSchema: GenMessage<UpdateConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 3);

/**
 * 工種タイプ更新レスポンス
 *
 * @generated from message api_proto.v1.UpdateConstructionTypeResponse
 */
export type UpdateConstructionTypeResponse = Message<"api_proto.v1.UpdateConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.ConstructionType construction_type = 1;
   */
  constructionType?: ConstructionType;
};

/**
 * Describes the message api_proto.v1.UpdateConstructionTypeResponse.
 * Use `create(UpdateConstructionTypeResponseSchema)` to create a new message.
 */
export const UpdateConstructionTypeResponseSchema: GenMessage<UpdateConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 4);

/**
 * 工種タイプ削除リクエスト
 *
 * @generated from message api_proto.v1.DeleteConstructionTypeRequest
 */
export type DeleteConstructionTypeRequest = Message<"api_proto.v1.DeleteConstructionTypeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.DeleteConstructionTypeRequest.
 * Use `create(DeleteConstructionTypeRequestSchema)` to create a new message.
 */
export const DeleteConstructionTypeRequestSchema: GenMessage<DeleteConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 5);

/**
 * 工種タイプ削除レスポンス
 *
 * @generated from message api_proto.v1.DeleteConstructionTypeResponse
 */
export type DeleteConstructionTypeResponse = Message<"api_proto.v1.DeleteConstructionTypeResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteConstructionTypeResponse.
 * Use `create(DeleteConstructionTypeResponseSchema)` to create a new message.
 */
export const DeleteConstructionTypeResponseSchema: GenMessage<DeleteConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 6);

/**
 * 工種タイプ詳細取得リクエスト
 *
 * @generated from message api_proto.v1.GetConstructionTypeRequest
 */
export type GetConstructionTypeRequest = Message<"api_proto.v1.GetConstructionTypeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.GetConstructionTypeRequest.
 * Use `create(GetConstructionTypeRequestSchema)` to create a new message.
 */
export const GetConstructionTypeRequestSchema: GenMessage<GetConstructionTypeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 7);

/**
 * 工種タイプ詳細取得レスポンス
 *
 * @generated from message api_proto.v1.GetConstructionTypeResponse
 */
export type GetConstructionTypeResponse = Message<"api_proto.v1.GetConstructionTypeResponse"> & {
  /**
   * @generated from field: api_proto.v1.ConstructionType construction_type = 1;
   */
  constructionType?: ConstructionType;
};

/**
 * Describes the message api_proto.v1.GetConstructionTypeResponse.
 * Use `create(GetConstructionTypeResponseSchema)` to create a new message.
 */
export const GetConstructionTypeResponseSchema: GenMessage<GetConstructionTypeResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 8);

/**
 * 工種タイプリスト取得リクエスト
 *
 * @generated from message api_proto.v1.GetConstructionTypeListRequest
 */
export type GetConstructionTypeListRequest = Message<"api_proto.v1.GetConstructionTypeListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;
};

/**
 * Describes the message api_proto.v1.GetConstructionTypeListRequest.
 * Use `create(GetConstructionTypeListRequestSchema)` to create a new message.
 */
export const GetConstructionTypeListRequestSchema: GenMessage<GetConstructionTypeListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 9);

/**
 * 工種タイプリスト取得レスポンス
 *
 * @generated from message api_proto.v1.GetConstructionTypeListResponse
 */
export type GetConstructionTypeListResponse = Message<"api_proto.v1.GetConstructionTypeListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.ConstructionType construction_types = 1;
   */
  constructionTypes: ConstructionType[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: int64 total_page = 3;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.GetConstructionTypeListResponse.
 * Use `create(GetConstructionTypeListResponseSchema)` to create a new message.
 */
export const GetConstructionTypeListResponseSchema: GenMessage<GetConstructionTypeListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_construction_types, 10);

